const urlParams = new URLSearchParams(window.location.search);
const calorieIntake1 = parseFloat(urlParams.get('calorieIntake1')) || 0;
const calorieIntake2 = parseFloat(urlParams.get('calorieIntake2')) || 0;
const proteinIntake = parseFloat(urlParams.get('proteinIntake')) || 0;
const fatIntake = parseFloat(urlParams.get('fatIntake')) || 0;
const carbohydratesIntake = parseFloat(urlParams.get('carbohydrates')) || 0;

function setTextContent(id, value) {
  const element = document.getElementById(id);
  if (element) {
    element.textContent = value;
  }
}

function ensureVidalyticsPlayerHelper() {
  if (typeof window.getVidalyticsPlayer === 'function') {
    return;
  }

  // Vidalytics exposes the player object asynchronously on `window._vidalytics.embeds`.
  !(function (v, a, p, i) {
    v.getVidalyticsPlayer = (embedId) => {
      v[a] = v[a] || {};
      v[a][p] = v[a][p] || {};

      let descriptor = v[a][p][embedId] = v[a][p][embedId] || {};

      return new Promise((resolve) => {
        if (descriptor[i]) {
          resolve(descriptor[i]);
          return;
        }

        let playerInstance;
        Object.defineProperty(descriptor, i, {
          configurable: true,
          get() {
            return playerInstance;
          },
          set(player) {
            playerInstance = player;
            resolve(player);
          },
        });
      });
    };
  })(window, '_vidalytics', 'embeds', 'player');
}

function revealResults(results) {
  if (!results || results.classList.contains('is-visible')) {
    return;
  }

  results.classList.add('is-visible');
  results.setAttribute('aria-hidden', 'false');

  if (typeof results.scrollIntoView === 'function') {
    results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

// Stage timings are authored for a 180 s timeline and scaled to the section's total duration.
const PROGRESS_STAGES_REFERENCE_DURATION = 180;
const PROGRESS_STAGES = [
  { end: 15, percentage: 14, label: 'Wir lesen deine Antworten ein …' },
  { end: 35, percentage: 32, label: 'Wir gleichen dein Profil mit 500.000 Daten ab …' },
  { end: 55, percentage: 48, label: 'Wir bestimmen deinen Stoffwechseltyp …' },
  { end: 80, percentage: 65, label: 'Wir identifizieren deine 4 Blockaden …' },
  { end: 105, percentage: 79, label: 'Wir berechnen deinen Kalorien- & Makro-Bedarf …' },
  { end: 130, percentage: 90, label: 'Wir wählen die passenden Mahlzeiten für dich …' },
  { end: 155, percentage: 97, label: 'Wir stellen deinen Masterplan zusammen …' },
  { end: 180, percentage: 100, label: 'Abschließende Plausibilitätsprüfung …' },
];

const LABEL_FADE_DURATION = 300;

function getProgressState(elapsed, totalDuration) {
  const scale = totalDuration / (PROGRESS_STAGES_REFERENCE_DURATION * 1000);
  let stageStart = 0;
  let stageStartPercentage = 0;

  for (let i = 0; i < PROGRESS_STAGES.length; i++) {
    const stage = PROGRESS_STAGES[i];
    const stageEnd = stage.end * 1000 * scale;

    if (elapsed < stageEnd) {
      const stageProgress = (elapsed - stageStart) / Math.max(stageEnd - stageStart, 1);

      return {
        percentage: Math.round(
          stageStartPercentage + (stage.percentage - stageStartPercentage) * stageProgress
        ),
        label: stage.label,
      };
    }

    stageStart = stageEnd;
    stageStartPercentage = stage.percentage;
  }

  return {
    percentage: 100,
    label: PROGRESS_STAGES[PROGRESS_STAGES.length - 1].label,
  };
}

function createTimelineController(section, progressBarContainer, progressBar, progressText, progressLabel, spinner, results) {
  let started = false;
  let progressInterval = null;
  let startTime = null;
  let pausedTime = 0;
  let isPaused = false;
  let pauseStartTime = 0;
  let hasCompleted = false;

  function getTotalDuration() {
    return parseInt(section.dataset.totalDuration, 10) * 1000 || PROGRESS_STAGES_REFERENCE_DURATION * 1000;
  }

  let currentLabel = PROGRESS_STAGES[0].label;
  let labelFadeTimeout = null;

  // Fade the old text out, swap it, then fade the new text in.
  function setLabel(label) {
    if (!progressLabel || currentLabel === label) {
      return;
    }

    currentLabel = label;
    clearTimeout(labelFadeTimeout);
    progressLabel.style.opacity = '0';
    progressLabel.style.transform = 'translateY(-4px)';

    labelFadeTimeout = setTimeout(() => {
      progressLabel.textContent = label;
      const transition = progressLabel.style.transition;
      progressLabel.style.transition = 'none';
      progressLabel.style.transform = 'translateY(4px)';
      void progressLabel.offsetWidth;
      progressLabel.style.transition = transition;
      progressLabel.style.opacity = '1';
      progressLabel.style.transform = 'translateY(0)';
    }, LABEL_FADE_DURATION);
  }

  function hideProgressBar() {
    if (!progressBarContainer) {
      return;
    }

    setTimeout(() => {
      progressBarContainer.style.transition = 'opacity 0.5s ease-out';
      progressBarContainer.style.opacity = '0';

      setTimeout(() => {
        progressBarContainer.style.display = 'none';
      }, 500);
    }, 500);
  }

  function completeTimeline() {
    if (hasCompleted) {
      return;
    }

    hasCompleted = true;
    if (progressInterval) {
      clearInterval(progressInterval);
    }

    progressBarContainer.style.display = 'block';
    progressBarContainer.style.opacity = '1';
    progressBar.style.width = '100%';

    if (progressText) {
      progressText.textContent = '100%';
    }

    if (spinner) {
      spinner.style.display = 'none';
    }

    hideProgressBar();
    revealResults(results);
  }

  function updateProgress() {
    if (progressInterval) {
      clearInterval(progressInterval);
    }

    const totalDuration = getTotalDuration();

    progressInterval = setInterval(function () {
      if (isPaused || hasCompleted) {
        return;
      }

      const elapsed = Date.now() - startTime - pausedTime;
      const { percentage, label } = getProgressState(elapsed, totalDuration);

      setLabel(label);

      if (progressText) {
        progressText.textContent = percentage + '%';
      }

      progressBar.style.width = percentage + '%';

      if (percentage >= 100) {
        completeTimeline();
      }
    }, 50);
  }

  return {
    hasStarted() {
      return started;
    },
    startTimeline() {
      if (hasCompleted) {
        return;
      }

      if (started) {
        this.resumeTimeline();
        return;
      }

      started = true;
      progressBarContainer.style.display = 'block';
      progressBarContainer.style.opacity = '1';
      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';

      if (progressText) {
        progressText.textContent = '0%';
      }

      setLabel(PROGRESS_STAGES[0].label);

      if (spinner) {
        spinner.style.display = 'inline-block';
      }

      void progressBar.offsetWidth;
      progressBar.style.transition = 'width 1s ease-out';

      startTime = Date.now();
      updateProgress();
    },
    resumeTimeline() {
      if (hasCompleted || !started || !isPaused) {
        return;
      }

      pausedTime += Date.now() - pauseStartTime;
      isPaused = false;

      if (spinner) {
        spinner.style.display = 'inline-block';
      }
    },
    pauseTimeline() {
      if (hasCompleted || !started || isPaused) {
        return;
      }

      isPaused = true;
      pauseStartTime = Date.now();

      if (spinner) {
        spinner.style.display = 'none';
      }
    },
    completeTimeline,
    revealResults() {
      revealResults(results);
    },
  };
}

function attachPlayerEvents(player, timeline, options = {}) {
  const activationEvents = Array.isArray(options.activationEvents)
    ? options.activationEvents
    : [];
  let isActivated = activationEvents.length === 0;

  function activateTimeline() {
    isActivated = true;

    if (!timeline.hasStarted()) {
      timeline.startTimeline();
      return;
    }

    timeline.resumeTimeline();
  }

  activationEvents.forEach(function (eventName) {
    player.on(eventName, function () {
      activateTimeline();
    });
  });

  player.on('play', function () {
    if (!isActivated) {
      return;
    }

    if (!timeline.hasStarted()) {
      timeline.startTimeline();
      return;
    }

    timeline.resumeTimeline();
  });

  player.on('pause', function () {
    if (!isActivated || !timeline.hasStarted()) {
      return;
    }

    timeline.pauseTimeline();
  });

  player.on('timeupdate', function () {
    if (!isActivated) {
      return;
    }

    if (!timeline.hasStarted()) {
      timeline.startTimeline();
    }
  });

  player.on('ended', function () {
    if (!isActivated || !timeline.hasStarted()) {
      return;
    }

    timeline.completeTimeline();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setTextContent('calorie-intake-1', calorieIntake1.toFixed(0));
  setTextContent('calorie-intake-2', calorieIntake2.toFixed(0));
  setTextContent('protein-intake', proteinIntake.toFixed(0));
  setTextContent('fat-intake', fatIntake.toFixed(0));
  setTextContent('carbohydrates-intake', carbohydratesIntake.toFixed(0));

  const section = document.querySelector('.qlf-stoffwechsel-quiz-result');
  if (!section) {
    return;
  }

  const wrapper = section.querySelector('.video-wrapper');
  const results = section.querySelector('.quiz-results');
  if (!results) {
    return;
  }

  if (!wrapper) {
    revealResults(results);
    return;
  }

  wrapper.insertAdjacentHTML(
    'afterend',
    `<div id="loading-bar-container" style="display:none; max-width: 500px; margin: 20px auto;">
         <div class="loading-bar-label-container" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <span class="loading-bar-label" aria-live="polite" style="font-size: 0.75rem; font-weight: 700; display: inline-block; transition: opacity ${LABEL_FADE_DURATION}ms ease, transform ${LABEL_FADE_DURATION}ms ease;">${PROGRESS_STAGES[0].label}</span>
            <span style="display: flex; align-items: center; gap: 8px;">
               <svg id="loading-spinner" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#fdd539" style="display: inline-block;">
                  <style>
                     .spinner_6kVp{transform-origin:center;animation:spinner_svv2 .75s infinite linear}@keyframes spinner_svv2{100%{transform:rotate(360deg)}}
                  </style>
                  <path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/>
               </svg>
               <span class="loading-bar-percentage" style="font-size: 0.75rem; font-weight: 700; width: auto; display: inline-block;">0%</span>
            </span>
         </div>
         <div class="loading-bar-wrapper">
            <div class="loading-bar-track" style="width: 100%; height: 8px; background-color: #e5e7eb; border-radius: 9999px; overflow: hidden;">
               <div class="loading-bar-fill" style="height: 100%; background-color: #fdd539; border-radius: 9999px; width: 0; transition: width 1s ease-out;"></div>
            </div>
         </div>
      </div>`
  );

  const progressBarContainer = section.querySelector('#loading-bar-container');
  const progressBar = progressBarContainer
    ? progressBarContainer.querySelector('.loading-bar-fill')
    : null;
  const progressText = progressBarContainer
    ? progressBarContainer.querySelector('.loading-bar-percentage')
    : null;
  const progressLabel = progressBarContainer
    ? progressBarContainer.querySelector('.loading-bar-label')
    : null;
  const spinner = progressBarContainer
    ? progressBarContainer.querySelector('#loading-spinner')
    : null;

  if (!progressBarContainer || !progressBar) {
    revealResults(results);
    return;
  }

  const timeline = createTimelineController(
    section,
    progressBarContainer,
    progressBar,
    progressText,
    progressLabel,
    spinner,
    results
  );

  const iframe = wrapper.querySelector('iframe');
  if (
    iframe &&
    iframe.src &&
    iframe.src.includes('player.vimeo.com') &&
    window.Vimeo &&
    typeof window.Vimeo.Player === 'function'
  ) {
    attachPlayerEvents(new Vimeo.Player(iframe), timeline);
    return;
  }

  const vidalyticsEmbed = wrapper.querySelector('[id^="vidalytics_embed_"]');
  if (vidalyticsEmbed && vidalyticsEmbed.id) {
    ensureVidalyticsPlayerHelper();
    window.getVidalyticsPlayer(vidalyticsEmbed.id).then(function (player) {
      if (!player) {
        timeline.revealResults();
        return;
      }

      attachPlayerEvents(player, timeline, {
        activationEvents: ['play:manual', 'unmute', 'enterfullscreen'],
      });
    });
    return;
  }

  timeline.revealResults();
});
